var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.625 10.9999C20.625 10.8176 20.5526 10.6427 20.4236 10.5138C20.2947 10.3848 20.1198 10.3124 19.9375 10.3124H3.72213L8.04926 5.98664C8.11318 5.92272 8.16388 5.84684 8.19848 5.76332C8.23307 5.6798 8.25088 5.59029 8.25088 5.49989C8.25088 5.40949 8.23307 5.31998 8.19848 5.23646C8.16388 5.15295 8.11318 5.07706 8.04926 5.01314C7.98534 4.94922 7.90945 4.89852 7.82594 4.86392C7.74242 4.82933 7.65291 4.81152 7.56251 4.81152C7.47211 4.81152 7.3826 4.82933 7.29908 4.86392C7.21556 4.89852 7.13968 4.94922 7.07576 5.01314L1.57576 10.5131C1.51173 10.577 1.46094 10.6529 1.42628 10.7364C1.39162 10.8199 1.37378 10.9095 1.37378 10.9999C1.37378 11.0903 1.39162 11.1799 1.42628 11.2634C1.46094 11.3469 1.51173 11.4228 1.57576 11.4866L7.07576 16.9866C7.13968 17.0506 7.21556 17.1013 7.29908 17.1359C7.3826 17.1705 7.47211 17.1883 7.56251 17.1883C7.65291 17.1883 7.74242 17.1705 7.82594 17.1359C7.90945 17.1013 7.98534 17.0506 8.04926 16.9866C8.11318 16.9227 8.16388 16.8468 8.19848 16.7633C8.23307 16.6798 8.25088 16.5903 8.25088 16.4999C8.25088 16.4095 8.23307 16.32 8.19848 16.2365C8.16388 16.1529 8.11318 16.0771 8.04926 16.0131L3.72213 11.6874H19.9375C20.1198 11.6874 20.2947 11.615 20.4236 11.486C20.5526 11.3571 20.625 11.1822 20.625 10.9999Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.566efb3adbeef3aa83e03c5703ebf284.svg";
export { ForwardRef as ReactComponent };